import { Box, styled } from '@mui/material'

export const ImageWrapper = styled(Box)(() => ({
  width: '100%',
  height: 190,
  overflow: 'hidden',
}))
